module.exports = __webpack_public_path__ + "img/avt2.9b11cc3a.0f85e0b7.png";